import storage from 'store';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import router from './router';
import store from './store';
import genRouter from './router/asyncRouterConfig';

const ACCESS_TOKEN = 'ACCESS_TOKEN';

NProgress.configure({ showSpinner: false });

const whiteList = ['/user/login', '/auth-redirect'];

router.beforeEach(async (to, from, next) => {
  NProgress.start();
  const hasToken = storage.get(ACCESS_TOKEN);
  if (hasToken) {
    if (to.path === '/user/login') {
      next();
      NProgress.done();
    } else {
      const hasUserInfo = store.state.user.info.username;
      if (hasUserInfo) {
        next();
      } else {
        try {
          await store.dispatch('getInitData');
          const { permissions, isSuperAdmin } = store.state.user.info;
          genRouter(isSuperAdmin, permissions);
          next({ ...to, replace: true });
        } catch (error) {
          console.log(error);
          // await store.dispatch('user/resetToken');
          // Modal.error(error || 'Has Error');
          // next(`/login?redirect=${to.path}`);
          NProgress.done();
        }
      }
    }
  } else if (whiteList.indexOf(to.path) !== -1) {
    next();
  } else {
    next(`/user/login?redirect=${to.path}`);
    NProgress.done();
  }
});

router.afterEach(() => {
  NProgress.done();
});
